import axios from '@axios'

const group = 'salary_and_commission/'
const route = 'advance_money'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, { itemsPerPage, page, search }) {
      return axios.get(`${group + route}?page=${page}&items_per_page=${itemsPerPage}&search=${search}`)
    },

    store(context, stage) {
      return axios.post(group + route, stage)
    },

    update(context, stage) {
      return axios.put(`${group + route}/${stage.id}`, stage)
    },

    destroy(context, stage) {
      return axios.delete(`${group + route}/${stage.id}`)
    },

  },
}
